import { IMAGE_LABEL } from '@components/imageHandling/common';

import type { AddImageLabelProps } from '@components/machines/components/detailsComponents/activeMachine/components/Images/components/AddImageLabel';
import i18n from 'i18n-js';

export interface UseManageAddImageLabelParams extends Pick<AddImageLabelProps, 'machineId' | 'documentRetrieveKey'> {}

export const useManageAddImageLabel = ({ machineId, documentRetrieveKey }: UseManageAddImageLabelParams) => {
  const entityName = machineId ? IMAGE_LABEL.Machine : documentRetrieveKey ? IMAGE_LABEL[documentRetrieveKey] : '';

  const computedText = i18n.t('Add {{entityName}} Image', { entityName });
  const fallBackText = i18n.t('Add Image or Document');
  const text = entityName ? computedText : fallBackText;

  return { text };
};
